module.exports = __webpack_public_path__ + "static/media/animation.6afdc8f7.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/animation.gif
// module id = 411
// module chunks = 0